import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';

import classnames from 'classnames';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import { useOnElementWidthChange } from '../../../../../hooks/use-on-element-width-change';
import { useSidePanelContext } from '../../../side-panel';
import { SelectedContentGridLayout } from '../selected-content-grid-layout';

import style from './resize-observer-layout.module.less';

const SingleColumnContainerWidthBreakpoint = 888;

/**
 * @param {object} props
 * @param {React.ReactNode} [props.column1Sections]
 * @param {React.ReactNode} [props.column2Sections]
 * @param {React.ReactNode} [props.column3Sections]
 * @param {React.ReactNode} props.fulfillmentPlannerSections
 * @param {React.ReactNode} props.primaryShipmentSections
 * @param {React.ReactNode} [props.rateCard]
 * @param {React.ReactNode} props.secondaryShipmentSections
 * @returns {JSX.Element}
 */
export const LayoutContainer = ({
  column1Sections,
  column2Sections,
  column3Sections,
  primaryShipmentSections,
  fulfillmentPlannerSections,
  secondaryShipmentSections,
  rateCard = null,
}) => {
  const [shouldUseSingleColumnLayout, setShouldUseSingleColumnLayout] = useState(false);
  const [isLayoutLoaded, setIsLayoutLoaded] = useState(false);

  const containerRef = useRef(null);

  const { sidePanelContent } = useSidePanelContext();

  const updateLayout = useCallback((width) => {
    if (width) {
      if (width < SingleColumnContainerWidthBreakpoint) {
        setShouldUseSingleColumnLayout(true);
      } else {
        setShouldUseSingleColumnLayout(false);
      }
    }
  }, []);

  useLayoutEffect(() => {
    if (containerRef.current) {
      updateLayout(containerRef.current.offsetWidth);
      setIsLayoutLoaded(true);
    }
  }, [updateLayout, containerRef, sidePanelContent.name]);

  useOnElementWidthChange(containerRef, updateLayout);

  return (
    <div ref={containerRef} className={style['order-details-selected-content-grid-layout-container']}>
      {isLayoutLoaded ? (
        <SelectedContentGridLayout
          className={classnames(style['order-details-selected-content-grid-layout'], {
            [style['single-column']]: shouldUseSingleColumnLayout,
          })}
          column1Sections={column1Sections}
          column2Sections={column2Sections}
          column3Sections={column3Sections}
          fulfillmentPlannerSections={fulfillmentPlannerSections}
          primaryShipmentSections={primaryShipmentSections}
          rateCard={rateCard}
          secondaryShipmentSections={secondaryShipmentSections}
        />
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
};
